import React from 'react'
import { CommonSelect, FadeFromBottomModal } from '@components'
import { App, Env } from '@config'
import Storage from '@src/utils/storage'
import { Button } from '@src/components/base'
import { StyleService } from '@src/style/service'
import { getEndpointSelectItems } from './endpointSelectItems'

interface AdminModalProps {
  onSelect: (option: { value: Env }) => void
  onCancelPress: () => void
  selectedOption: Env
}

export const AdminModal = (props: AdminModalProps) => {
  const { onSelect, onCancelPress, selectedOption } = props
  const endpointSelectItems = getEndpointSelectItems(App.build.development)

  const option = endpointSelectItems.find((option) => option.value === selectedOption)

  const onClearStoragePress = () => {
    Storage.clear()
    onCancelPress()
  }

  return (
    <FadeFromBottomModal title="Admin Settings" closeModal={onCancelPress}>
      <CommonSelect
        options={endpointSelectItems}
        selectedOption={option}
        onSelect={onSelect}
        size="small"
      />
      <Button
        size="small"
        onPress={onClearStoragePress}
        type="outline"
        accessibilityLabel="Clear Storage"
        style={styles.button}
      >
        Clear Storage
      </Button>
    </FadeFromBottomModal>
  )
}

const styles = StyleService.create({
  button: {
    marginTop: 16,
    width: '100%',
  },
})
